import React from 'react'

const LinkCard = ({ path = undefined, children = null }) => {
  return <a href={path} className='vega link'>{children}</a>
}

export default LinkCard
